/* eslint-disable */
/**
 * The install method for the Zendesk Vue plugin.
 * @param {import('vue').App} app
 * @param {object} options
 * @param {string} options.zendeskEnabled - Whether Zendesk is enabled ('true' or 'false')
 * @param {string} options.zendeskKey - The Zendesk snippet key
 */

import { useCustomerStore } from "@/stores/customer.js";

export function installZendesk(app, options) {
	const customerStore = useCustomerStore();
	const {
		zendeskEnabled,
		zendeskKey
	} = options;

	if (zendeskEnabled === 'true' && zendeskKey) {
		// Load Zendesk script
		const script = document.createElement('script');
		script.id = 'ze-snippet';
		script.async = true;
		script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;

		script.onload = () => {
			if (window.zE) {
				const htmlDir = document.documentElement.getAttribute('dir');
				const isRTL = htmlDir === 'rtl';

				window.zESettings = {
					webWidget: {
						zIndex: 1,
						offset: { horizontal: '20px', vertical: '50px' },
						position: { horizontal: isRTL ? 'left' : 'right', vertical: 'bottom' },
						mobile: {
							offset: { horizontal: '100px', vertical: '100px' }
						}
					}
				};


				if (customerStore.isLoggedIn) {

					window.zE('webWidget', 'prefill', {
						name: {
							value: customerStore.customer.username,
							readOnly: true // optional
						},
						email: {
							value: customerStore.customer.email,
							readOnly: true // optional
						},
					});
				}

				console.log('Zendesk widget configured');
			}
		};

		document.head.appendChild(script);
		console.log('Zendesk script loading...');
	}

	// Global helper for manual configuration if needed
	app.config.globalProperties.$configureZendesk = (config) => {
		if (window.zE) {
			window.zE('webWidget', 'update', config);
		}
	};
}
